// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ViewProps } from 'react-native';
import type { DirectEventHandler, Int32 } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
export type NativeMenuItem = Readonly<{
  parentId: string;
  type: string;
  id: string;
  title: string;
  systemImage: string;
  role: string;
  disabled: boolean;
  hidden: boolean;
  help: string;
  controlGroupStyle: string;
  values: ReadonlyArray<boolean>;
  selection: string;
  menuOrder: string;
  menuActionDismissBehavior: string;
}>;
interface NativeProps extends ViewProps {
  items: ReadonlyArray<NativeMenuItem>;
  triggerLabel: string;
  disabled: boolean;
  hasPrimaryAction: boolean;
  menuOrder: string;
  menuActionDismissBehavior: string;
  presentation: string;
  acknowledgedEvent: Int32;
  revision: Int32;
  pickerAcknowledgedEvent: Int32;
  onNativeMenuAction?: DirectEventHandler<Readonly<{
    id: string;
  }>>;
  onNativeMenuPrimaryAction?: DirectEventHandler<Readonly<{
    kind: string;
  }>>;
  onNativeMenuValueChange?: DirectEventHandler<Readonly<{
    id: string;
    value: boolean;
    sourceIndex: Int32;
    eventCount: Int32;
    revision: Int32;
  }>>;
  onNativeMenuPickerChange?: DirectEventHandler<Readonly<{
    id: string;
    value: string;
    eventCount: Int32;
    revision: Int32;
  }>>;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
let nativeComponentName = 'OneNativeMenu';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeMenu",
  directEventTypes: {
    topNativeMenuAction: {
      registrationName: "onNativeMenuAction"
    },
    topNativeMenuPrimaryAction: {
      registrationName: "onNativeMenuPrimaryAction"
    },
    topNativeMenuValueChange: {
      registrationName: "onNativeMenuValueChange"
    },
    topNativeMenuPickerChange: {
      registrationName: "onNativeMenuPickerChange"
    }
  },
  validAttributes: {
    items: true,
    triggerLabel: true,
    disabled: true,
    hasPrimaryAction: true,
    menuOrder: true,
    menuActionDismissBehavior: true,
    presentation: true,
    acknowledgedEvent: true,
    revision: true,
    pickerAcknowledgedEvent: true,
    ...ConditionallyIgnoredEventHandlers({
      onNativeMenuAction: true,
      onNativeMenuPrimaryAction: true,
      onNativeMenuValueChange: true,
      onNativeMenuPickerChange: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);